import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import { IAtendimentoExtraDetalhado } from "../../../../Interfaces/Geral/Atendimento/AtendimentoExtraDetalhadoInterfaces";
import OrSpinner from "../../../../Components/Utils/OrSpinner";
import IconOrSpinner from "../../../../Components/Utils/IconOrSpinner";
import {
    faBackward,
    faForward,
    faInfoCircle,
    faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { useHistoricoContext } from "../../../../Context/Historico";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import {
    AvancarEtapaVendasController,
    ListarEtapasVendasController,
} from "../../../../Controllers/Vendas/Caso/CasoController";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { CancelarCaso } from "../../../../Components/CardsPages/Atendimento/CancelarCaso";
import ModalComponent from "../../../../Components/Modais";
import { useState } from "react";
import { IComponentModal } from "../../../../Components/Modais/IModalComponent";

interface IAcoesVendas {
    bloquearAcoes: boolean;
}

export default function AcoesVendas(props: IAcoesVendas) {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const { updateAtendimento } = useAtendimentoPage();
    const Atendimento = useAtendimentoPage()
        .Atendimento as IAtendimentoExtraDetalhado;

    const { ReloadHistorico } = useHistoricoContext();

    const { execute: AvancarEtapaVendas, loading: AvancarEtapaVendasLoading } =
        useAsyncCallback(AvancarEtapaVendasController);

    const { value: lstEtapas, loading: lstEtapasLoading } = useAsyncEffect(
        () => ListarEtapasVendasController(),
        [Atendimento.ID_ETAPA_TIPO_CASO]
    );

    return (
        <div className="card card-custom px-8 py-4 my-5">
            <h4 className="text-center mb-0">Ações de Etapa</h4>
            <hr />
            {!!props.bloquearAcoes && (
                <span className="w-100 d-flex justify-content-center align-items-center g-2">
                    Ações bloqueadas porque os status obrigatórios não foram
                    preenchidos{" "}
                    <FontAwesomeIcon
                        size="1x"
                        className="svg-icon svg-icon-md mr-1 d-lg-flex"
                        icon={faInfoCircle}
                    />
                </span>
            )}

            <div className="g-5  d-flex flex-row flex-wrap justify-content-center">
                <OrSpinner
                    loading={lstEtapasLoading}
                    spinner="capys"
                    loadingSize="lg"
                >
                    <>
                        {lstEtapas
                            ?.filter(
                                (etapaAtual) =>
                                    etapaAtual.NR_ETAPA ===
                                    Atendimento.NR_ETAPA - 1
                            )
                            ?.map((etapa, index) => {
                                return (
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-primary m-1"
                                        disabled={AvancarEtapaVendasLoading}
                                        onClick={() => {
                                            if (Atendimento?.ID_CASO) {
                                                AvancarEtapaVendas(
                                                    Atendimento.ID_CASO,
                                                    etapa.ID_ETAPA_TIPO_CASO
                                                ).then(() => {
                                                    updateAtendimento();
                                                    ReloadHistorico();
                                                });
                                            }
                                        }}
                                    >
                                        <IconOrSpinner
                                            icon={faBackward}
                                            loadingSize="sm"
                                            loading={AvancarEtapaVendasLoading}
                                            className="mr-2"
                                        />{" "}
                                        Voltar para Etapa: {etapa.DS_ETAPA}
                                    </button>
                                );
                            })}
                        {lstEtapas
                            ?.filter(
                                (etapaAtual) =>
                                    etapaAtual.NR_ETAPA ===
                                    Atendimento.NR_ETAPA + 1
                            )
                            ?.map((etapa, index) => {
                                return (
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-primary m-1"
                                        disabled={
                                            AvancarEtapaVendasLoading ||
                                            props.bloquearAcoes
                                        }
                                        onClick={() => {
                                            if (Atendimento?.ID_CASO) {
                                                AvancarEtapaVendas(
                                                    Atendimento.ID_CASO,
                                                    etapa.ID_ETAPA_TIPO_CASO
                                                ).then(() => {
                                                    updateAtendimento();
                                                    ReloadHistorico();
                                                });
                                            }
                                        }}
                                    >
                                        <IconOrSpinner
                                            icon={faForward}
                                            loadingSize="sm"
                                            loading={AvancarEtapaVendasLoading}
                                            className="mr-2"
                                        />{" "}
                                        Avançar para Etapa: {etapa.DS_ETAPA}
                                    </button>
                                );
                            })}
                        <button
                            type="button"
                            className="btn btn-sm btn-danger m-1"
                            disabled={
                                AvancarEtapaVendasLoading || props.bloquearAcoes
                            }
                            onClick={() => {
                                setShow(true);
                                setModal({
                                    headerComponent: "Encerrar Atendimento",
                                    IconHeader: faTimes,
                                    Component: () => (
                                        <CancelarCaso
                                            setShow={setShow}
                                            Atendimento={Atendimento!}
                                        />
                                    ),
                                    size: "lg",
                                });
                            }}
                        >
                            <IconOrSpinner
                                icon={faTimes}
                                loadingSize="sm"
                                loading={AvancarEtapaVendasLoading}
                                className="mr-2"
                            />{" "}
                            Encerrar Atendimento
                        </button>
                    </>
                </OrSpinner>
            </div>
            <ModalComponent
                setShow={setShow}
                show={show}
                ModalComponent={modal}
            />
        </div>
    );
}
